import React, { useState, useEffect } from 'react';
import axios from "axios";

const ManageStudents = () => {
    const [students, setStudents] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentStudent, setCurrentStudent] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        roll_no: '',
        email: '',
        password: '',
        program: '',
        semester: ''
    });

    const [programs, setPrograms] = useState([]);
    const [semesters, setSemesters] = useState([]);

    const [filteredSemesters, setFilteredSemesters] = useState([]);
    useEffect(() => {
        fetchStudents();

        fetch("http://localhost:8081/api/admin/programs")
            .then(res => res.json())
            .then(data => setPrograms(data));

        fetch("http://localhost:8081/api/admin/semesters")
            .then(res => res.json())
            .then(data => setSemesters(data));
    }, []);

    const fetchStudents = async () => {
        try {
            const res = await axios.get('http://localhost:8081/api/admin/students');
            setStudents(res.data);
        } catch (err) {
            console.error('Error fetching students:', err);
        }
    };

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    useEffect(() => {
        if (formData.program) {
            const filtered = semesters.filter(s => s.program_id === parseInt(formData.program));
            setFilteredSemesters(filtered);
        }
    }, [formData.program, semesters]);

    const handleSave = async () => {
        // Validation
        const nameRegex = /^[A-Za-z\s]+$/;
        const rollRegex = /^[0-9\-]+$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!formData.name.trim() || !nameRegex.test(formData.name)) {
            alert("Please enter a valid name (letters and spaces only).");
            return;
        }
        console.log(formData.roll_no);
        if (!formData.roll_no.trim() || !rollRegex.test(formData.roll_no)) {
            alert("Please enter a valid roll number (letters, numbers, and dashes only).");
            return;
        }

        if (!formData.email.trim() || !emailRegex.test(formData.email)) {
            alert("Please enter a valid email address.");
            return;
        }

        if (!isEditMode && (!formData.password || formData.password.length < 6)) {
            alert("Password must be at least 6 characters.");
            return;
        }

        if (!formData.program) {
            alert("Please select a program.");
            return;
        }

        if (!formData.semester) {
            alert("Please select a semester.");
            return;
        }

        try {
            if (isEditMode) {
                await axios.put(`http://localhost:8081/api/admin/students/${currentStudent.user_id}`, formData);
            } else {
                await axios.post('http://localhost:8081/api/admin/students', formData);
            }

            setShowModal(false);
            setIsEditMode(false);
            setCurrentStudent(null);
            setFormData({
                name: '',
                roll_no: '',
                email: '',
                password: '',
                program: '',
                semester: ''
            });
            fetchStudents();
        } catch (err) {
            console.error('Error saving student:', err);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this student?')) {
            try {
                await axios.delete(`http://localhost:8081/api/admin/students/${id}`);
                fetchStudents();
            } catch (err) {
                console.error('Error deleting student:', err);
            }
        }
    };

    return (
        <div className="manage-students">
            <div className="header">
                <h2>Manage Students</h2>
                <button
                    className="add-btn"
                    onClick={() => {
                        setShowModal(true);
                        setIsEditMode(false);
                        setFormData({
                            name: '',
                            roll_no: '',
                            email: '',
                            password: '',
                            program: '',
                            semester: ''
                        });
                    }}
                >
                    + Add Student
                </button>
            </div>

            <table className="students-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Roll No</th>
                        <th>Program</th>
                        <th>Semester</th>
                        <th>Joined</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {students && students.length > 0 && students.map((student) => (
                        <tr key={student.user_id}>
                            <td>{student.full_name}</td>
                            <td>{student.roll_number}</td>
                            <td>{programs ? programs.map(prog => prog.id == student.program ? prog.name : "") : ""}</td>
                            <td>{semesters ? semesters.map(sem => sem.semester_id == student.semester ? sem.name : "") : ""}</td>
                            <td>{new Date(student.created_at).toLocaleString()}</td>
                            <td>
                                <button
                                    className="edit"
                                    onClick={() => {
                                        setCurrentStudent(student);
                                        setFormData({
                                            name: student.full_name,
                                            roll_no: student.roll_number,
                                            email: student.email,
                                            password: '',
                                            program: student.program_id,
                                            semester: student.semester_id
                                        });
                                        setIsEditMode(true);
                                        setShowModal(true);
                                    }}
                                >
                                    Edit
                                </button>
                                <button className="delete" onClick={() => handleDelete(student.user_id)}>
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {showModal && (
                <div className="manage-students__modal-overlay">
                    <div className="manage-students__modal">
                        <h3>{isEditMode ? 'Edit Student' : 'Add Student'}</h3>
                        <input
                            name="name"
                            type="text"
                            placeholder="Full Name"
                            value={formData.name}
                            onChange={handleInputChange}
                        />
                        <input
                            name="roll_no"
                            type="text"
                            placeholder="Roll Number"
                            value={formData.roll_no}
                            onChange={handleInputChange}
                        />
                        <input
                            name="email"
                            type="email"
                            placeholder="Email Address"
                            value={formData.email}
                            onChange={handleInputChange}
                        />
                        <input
                            name="password"
                            type="password"
                            placeholder="Password"
                            value={formData.password}
                            onChange={handleInputChange}
                        />
                        <select name="program" value={formData.program} onChange={handleInputChange}>
                            <option value="">Select Programs</option>
                            {programs.map((p) => (
                                <option key={p.id} value={p.id}>{p.name}</option>
                            ))}
                        </select>
                        <select name="semester" value={formData.semester} onChange={handleInputChange}>
                            <option value="">Select Semester</option>
                            {filteredSemesters.map((s) => (
                                <option key={s.semester_id} value={s.semester_id}>{s.name}</option>
                            ))}
                        </select>
                        <div className="manage-students__modal-actions">
                            <button
                                onClick={() => {
                                    setShowModal(false);
                                    setIsEditMode(false);
                                    setCurrentStudent(null);
                                }}
                                className="cancel-btn"
                            >
                                Cancel
                            </button>
                            <button className="save-btn" onClick={handleSave}>
                                {isEditMode ? 'Update' : 'Save'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ManageStudents;
